<template>
    <CContainer>
        <h3>Indicadores de Ventas</h3>
        <CCard class="mt-4">
            <CCardHeader>
                <CRow>
                    <CCol col="sm-3">
                        <label class="col-sm-12 text-muted font-weight-bold">
                            Fecha Inicial:
                        </label>
                        <DatePicker 
                            type="date"
                            class="col-sm-12"
                            v-model="fechaInicial"
                            value-type="YYYY-MM-DD"
                            format="DD/MM/YYYY"
                            placeholder="dd/mm/yyyy" />
                    </CCol>
                    <CCol col="sm-3">
                        <label class="col-sm-12 text-muted font-weight-bold">
                            Fecha Final:
                        </label>
                        <DatePicker 
                            type="date"
                            class="col-sm-12"
                            v-model="fechaFinal"
                            value-type="YYYY-MM-DD"
                            format="DD/MM/YYYY"
                            placeholder="dd/mm/yyyy" />
                    </CCol>
                    <CCol col="sm-6">
                        <CButton 
                            color="info" 
                            variant="outline" 
                            class="mt-4"
                            @click="getDataKPISales()">
                            <CIcon name="cil-search" />
                            <span class="ml-2 align-middle">Consultar</span>
                        </CButton>
                    </CCol>
                </CRow>
            </CCardHeader>
            <CCardBody>
                <CRow>
                    <!-- <CCol col="sm-3">
                        <CWidgetIcon 
                            color="s3green" 
                            text="Valor de Ventas" 
                            :header="'$' + formatter.format(valorMercancia, 2) + 'M'" 
                            :icon-padding="false">
                            <i class="bi bi-cart3 h1"></i>
                        </CWidgetIcon>
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetIcon 
                            color="warning" 
                            text="Valor Costo"
                            :header="'$' + formatter.format(valorCosto, 2) + 'M'"
                            :icon-padding="false">
                            <i class="bi bi-cash-stack h1"></i>
                        </CWidgetIcon>
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetIcon
                            color="info"
                            text="Valor Utilidad"
                            :header="'$' + formatter.format(valorUtilidad, 2) + 'M'"
                            :icon-padding="false">
                            <i class="bi bi-graph-up-arrow h1"></i>
                        </CWidgetIcon>                                
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetIcon 
                            color="s3red" 
                            text="Remisiones" 
                            :header="'$' + formatter.format(123.45, 2) + 'M'"
                            :icon-padding="false">
                            <i class="bi bi-box-seam h1"></i>
                        </CWidgetIcon>
                    </CCol> -->
                    <CCol col="sm-3">
                        <CWidgetProgressIcon
                            color="s3green"
                            text="Valor de Ventas"
                            :value="0"
                            :header="'$' + formatter.format(valorMercancia, 2) + 'M'">
                            <template #progress>
                                <!-- <a href="#" v-if="$store.state.user.data.tipo_Empleado !== 'V'" -->
                                <a href="#"
                                    class="ml-2" 
                                    @click="() => {
                                        showChart = true
                                        showDetailSales = !showDetailSales
                                    }">
                                    <i :class="showDetailSales ? 'bi bi-caret-up-square' : 'bi bi-caret-down-square'"></i>
                                </a>
                                <a href="#" v-if="$store.state.user.data.tipo_Empleado === 'V'" 
                                    class="ml-2" 
                                    @click="() => {
                                        renderGridSalesProfit = true
                                        tipoReporte = 'C'
                                        updateComponentGrid += 1
                                        showPanelDetailUtility = true
                                    }">
                                    <i class="bi bi-journal-text"></i>
                                </a>
                            </template>
                            <i class="bi bi-cart3 h1 text-s3green"></i>
                        </CWidgetProgressIcon>                                
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetProgressIcon
                            text="Valor Costo"
                            color="warning"
                            :value="participacionCosto"
                            :header="'$' + formatter.format(valorCosto, 2) + 'M'">
                            <template #progress>
                                &nbsp;
                            </template>
                            <i class="bi bi-cash-stack h1 text-warning"></i>
                        </CWidgetProgressIcon>                                
                    </CCol>
                    <CCol col="sm-3">
                        <CWidgetProgressIcon
                            text="Valor Utilidad"
                            color="info"
                            :value="porcentajeUtilidad"
                            :header="'$' + formatter.format(valorUtilidad, 2) + 'M'">
                            <template #progress>
                                &nbsp;
                                <!-- <a href="#" @click="() => showDetailUtility = !showDetailUtility">
                                    <i class="bi bi-caret-down-square ml-2"></i>
                                </a> -->
                            </template>
                            <span class="small text-info mr-2">{{ porcentajeUtilidad }}%</span>
                            <i class="bi bi-graph-up-arrow h1 text-info"></i>
                        </CWidgetProgressIcon>                                
                    </CCol>
                    <!-- <CCol col="sm-3">
                        <CWidgetProgressIcon
                            text="Remisiones"
                            color="s3red"
                            :value="51"
                            :header="'$' + formatter.format(123.45, 2) + 'M'">
                            <template #progress>
                                &nbsp;
                            </template>
                            <span class="small text-s3red mr-2">00.00%</span>
                            <i class="bi bi-box-seam h1 text-s3red"></i>
                        </CWidgetProgressIcon>
                    </CCol> -->
                </CRow>
                <CRow>
                    <CCol col="sm-12">
                    </CCol>
                </CRow>
            </CCardBody>

            <CElementCover v-show="loading"/>
        </CCard>

        <CCollapse :show="showDetailSales">
            <CCard>
                <CCardBody>
                    <CRow>
                        <CCol col="sm-4" v-if="$store.state.user.data.tipo_Empleado === 'A' || $store.state.user.data.tipo_Empleado == 'D'">
                            <CCard>
                                <CCardBody>
                                    <div class="d-flex justify-content-end">
                                        <!-- <a href="#" v-c-tooltip="'Detallado por Grupo'" 
                                            class="mr-2" @click="() => {
                                                renderGridSalesProfit = true
                                                tipoReporte = 'G'
                                                updateComponentGrid += 1
                                                showPanelDetailUtility = true
                                            }">
                                            <i class="bi bi-people h4"></i>
                                        </a> -->
                                        <!-- <a href="#" v-c-tooltip="'Detallado por Comercial'" 
                                            class="mr-2"
                                            @click="() => {
                                                renderGridSalesProfit = true
                                                tipoReporte = 'V'
                                                updateComponentGrid += 1
                                                showPanelDetailUtility = true
                                            }">
                                            <i class="bi bi-person-badge h4"></i>
                                        </a> -->
                                        <a href="#" @click="() => {
                                            renderGridSalesProfit = true
                                            showPanelDetailUtility = true
                                            }">
                                            <i class="bi bi-three-dots h4"></i>
                                        </a>
                                    </div>
                                    <sales-participation-chart v-if="showChart"
                                        :title="titulo"
                                        :initialDate="fechaInicial" 
                                        :finalDate="fechaFinal" 
                                        :type-report="tipoReporte"
                                        :idEmployeeGroup="idGrupoEmpleado" 
                                        :idEmployee="null" 
                                        :min-percentage="minPercentage"
                                        :key="updateComponent">
                                    </sales-participation-chart>
                                </CCardBody>
                            </CCard>
                        </CCol>
                        <CCol col="sm-8">
                            <CCard>
                                <CCardBody>
                                    <div class="d-flex justify-content-end">
                                        <a href="#" 
                                            @click="() => {
                                                renderGridSalesProfit = true
                                                showPanelDetailCategoryUtility = true
                                            }">
                                            <i class="bi bi-three-dots h4"></i>
                                        </a>
                                    </div>
                                    <SalesParticipationCategoryChart 
                                        title="Participación Ventas por Categoría" 
                                        :initialDate="fechaInicial" 
                                        :finalDate="fechaFinal" 
                                        reportType="C" 
                                        utilityType="venta" 
                                        :idEmployee="idEmpleado"
                                        :valuesDivisor="divisorValores"
                                        :valuesSing="'M'"
                                        :key="updateComponent" >
                                    </SalesParticipationCategoryChart>
                                </CCardBody>
                            </CCard>
                        </CCol>
                        <!-- <CCol col="sm-4">
                            <h4>Participacion de ventas por ???</h4>
                        </CCol> -->
                    </CRow>
                </CCardBody>
            </CCard>
        </CCollapse>

        <CCollapse :show="showDetailUtility">
            <CCard>
                <CCardBody>
                    <div class="mt-2">
                        <a href="#" v-c-tooltip="'Utilidad por Grupo'" class="mr-2">
                            <i class="bi bi-people h2"></i>
                        </a>
                        <a href="#" v-c-tooltip="'Utilidad por Comercial'">
                            <i class="bi bi-person-badge h2"></i>
                        </a>
                    </div>
                </CCardBody>
            </CCard>
        </CCollapse>

        <CCard>
            <CCardBody>
                <CRow>
                    <CCol col="2">
                        <CButton 
                            color="info" 
                            variant="outline"
                            @click="goToUtilidadVentasDocumento()" >
                            <i class="bi bi-file-earmark-bar-graph h1"></i>
                            <br>
                            <span>Utilidad de Ventas por Documento</span>
                        </CButton>
                    </CCol>
                    <CCol col="sm-2" v-if="$store.state.user.data.tipo_Empleado === 'A'">
                        <CButton 
                            color="s3purple" 
                            variant="outline"
                            @click="goToPresupuestoVentaCategoria()" >
                            <i class="bi bi-bar-chart-line h1"></i>
                            <br>
                            <span>Presupuestos de Ventas Categor&iacute;as</span>
                        </CButton>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
        
        <RightSideBar :show="showPanelDetailUtility" size="lg" class="bg-s3grey">
            <CContainer>
                <CCard class="mt-4">
                    <CCardHeader>
                        <CCardTitle>
                            Ventas y Utilidades
                        </CCardTitle>
                        <CCardSubtitle>
                            Detalle de ventas y utilidades por {{ subtitulo }}.
                        </CCardSubtitle>
                    </CCardHeader>
                    <CCardBody>
                        <SalesProfit v-if="renderGridSalesProfit"
                            :initDate="fechaInicial" 
                            :endDate="fechaFinal" 
                            :reportType="tipoReporte" 
                            :utilityType="'venta'" 
                            :idEmployee="tipoReporte === 'C' ? $store.state.user.data.id_Empleado : null"
                            :key="updateComponentGrid">
                        </SalesProfit>
                    </CCardBody>
                    <CCardFooter>
                        <div class="d-flex justify-content-center">
                            <CButton 
                                color="primary"
                                @click="showPanelDetailUtility = false">
                                <CIcon name="cil-x-circle" />
                                <span class="align-middle mx-2">Cerrar</span>
                            </CButton>
                        </div>
                    </CCardFooter>
                </CCard>
            </CContainer>
        </RightSideBar>

        <RightSideBar :show="showPanelDetailCategoryUtility" size="lg" class="bg-s3grey">
            <CContainer>
                <CCard class="mt-4">
                    <CCardHeader>
                        <CCardTitle>

                        </CCardTitle>
                    </CCardHeader>
                </CCard>
            </CContainer>
        </RightSideBar>

    </CContainer>
</template>
<script>
    import "vue2-datepicker/index.css"
    import moment from "moment"
    import DatePicker from "vue2-datepicker"
    import { formatter } from "../../general"
    import { dataCostoVentasDocumentos } from "../../apiData"
    import RightSideBar from "../containers/RightSideBar.vue"
    import SalesParticipationChart from "../charts/SalesParticipationChart.vue"
    import SalesParticipationCategoryChart from "../charts/SalesParticipationCategoryChart.vue"
    import SalesProfit from "../datagrids/SalesProfit.vue"

    export default {
        name: "DashboardSales",
        data() {
            return {
                formatter,
                loading: false,
                updateComponent: 0,
                updateComponentGrid: 0,
                showChart: null,
                renderGridSalesProfit: null,
                showChartGroup: null,
                showDetailSales: false,
                showDetailUtility: false,
                showPanelDetailUtility: null,
                showPanelDetailCategoryUtility: null,
                divisorValores: 1000000,
                titulo: "",
                subtitulo: "",
                fechaInicial: "",
                fechaFinal: "",
                tipoReporte: "",
                minPercentage: 5,
                idGrupoEmpleado: null,
                idEmpleado: null,
                valorMercancia: 0,
                valorCosto: 0,
                valorUtilidad: 0,
                valorRemisiones: 0,
                participacionVentas: 0,
                participacionCosto: 0,
                porcentajeUtilidad: 0
            }
        },
        components: {
            DatePicker,
            RightSideBar,
            SalesParticipationChart,
            SalesParticipationCategoryChart,
            SalesProfit
        },
        methods: {
            async getDataKPISales() {
                this.loading = true

                try {
                    this.updateComponent += 1

                    this.getDataSalesAndCosts()
                } catch(error) {
                    console.log(error);
                } finally {
                    this.loading = false
                }
            },
            async getDataSalesAndCosts() {
                try {
                    const { response } = await dataCostoVentasDocumentos(
                        this,
                        this.fechaInicial,
                        this.fechaFinal,
                        "T",
                        "venta",
                        null,
                        this.$store.state.user.data.id_Empleado
                    )

                    this.valorMercancia = (response[0].Valor_Mercancia / this.divisorValores)
                    this.valorCosto = (response[0].Valor_Costo / this.divisorValores)
                    this.valorUtilidad = (response[0].Valor_Utilidad / this.divisorValores)
                    this.porcentajeUtilidad = response[0].Porcentaje_Utilidad

                    this.participacionCosto = ((this.valorCosto / this.valorMercancia) * 100)
                    this.participacionUtilidad = ((this.valorUtilidad / this.valorMercancia) * 100)

                    // this.idGrupoEmpleado = "4DtVl4Gg9Pg5Dq5Yk3Xh"
                    
                    // this.showChartGroup = true
                } catch (error) {
                    console.log(error);
                }
            },
            async getDataWareDelivery() {
                try {
                    console.log("");
                } catch(error) {
                    console.log(error);
                }
            },
            goToUtilidadVentasDocumento() {
                this.$router.push({
                    path: "/empresa/indicadores/dashboardventas/utilidadventasdocumentos"
                })
            },
            goToPresupuestoVentaCategoria() {
                this.$router.push({
                    path: "/empresa/indicadores/dashboardventas/ejecucionpresupuestoscategorias"
                })
            }
        },
        computed: {

        },
        async mounted() {
            this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD")
            this.fechaFinal = moment().format("YYYY-MM-DD")

            switch (this.$store.state.user.data.tipo_Empleado) {
                case "A":
                    this.tipoReporte = "G"
                    this.titulo = "Participacion Ventas por Grupos"
                    break
                case "D":
                    this.tipoReporte = "V"
                    this.titulo = "Participacion Ventas por Comerciales"
                    this.idGrupoEmpleado = this.$store.state.user.data.id_GrupoPersonal
                    break
                case "V":
                    this.idEmpleado = this.$store.state.user.data.id_Empleado
                    this.subtitulo = "Clientes"
                    break

            }

            // this.subtitulo = "Grupos"
            // this.subtitulo = "Comerciales"
            // this.subtitulo = "Facturas"

            await this.getDataKPISales()
        }
    }
</script>
